/**
 * Minimum set of polyfills for getting the app to run on IE 11 and
 * Samsung Internet Browser 4.
 */
import 'core-js/modules/es6.promise';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.array.fill';
import 'core-js/modules/es6.array.iterator';
import 'core-js/modules/es6.map';
import 'core-js/modules/es6.object.assign';
import 'core-js/modules/es6.string.includes';
import 'core-js/modules/es6.string.repeat';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es7.array.includes';
import 'core-js/modules/web.dom.iterable';

// DOM polyfills for IE 11
if (!Element.prototype.matches && Element.prototype.msMatchesSelector) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}
